<template>
  <div class="mt-5" style="overflow:hidden;background-color:white;">
    <b-row align-h="center">
      <b-col md="10 text-center">
         <h5> Your Account </h5>
      </b-col>
    </b-row>
       
    <b-row align-h="center" v-if="!isGuest">
        <b-col md="10">
         <b-card no-body class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-pwd>
               Your Name, Location, Password
             </b-button>
           </b-card-header>
           <b-collapse id="acc-pwd" accordion="my-accordion" role="tabpanel">
             <b-card-body>
              <b-card-text>
               <b-form-group class="pt-2">
                   <b-form-input
                    id="input-email"
                    type="email"
                    v-model="userForm.email"
                    disabled
                  ></b-form-input>
                </b-form-group>
               <b-form-group class="pt-2">
                   <b-form-input
                    id="input-roomname"
                    v-model="userForm.nick"
                    placeholder="-no room assigned-"
                    disabled
                  ></b-form-input>
                </b-form-group>
                <b-form-group class="pt-2">
                  <b-form-input
                    id="input-firstname"
                    v-model="userForm.first_name"
                    placeholder="Enter First Name"
                  ></b-form-input>
                  <b-form-input
                    id="input-lastname"
                    v-model="userForm.last_name"
                    placeholder="Enter Last Name"
                  ></b-form-input>
                </b-form-group>
               <b-form-group class="pt-2">
                 Your Location
                 <b-form-select v-model="userForm.country"
                    :options="loc_cts" size="sm" class="mt-3">
                   <template v-slot:first>
                     <b-form-select-option :value="null" disabled>-- Please select a Country --</b-form-select-option>
                     </template>
                 </b-form-select>
                 <b-form-select v-model="userForm.region"
                    :options="loc_rgs" size="sm" class="mt-3">
                    <template v-slot:first>
                     <b-form-select-option :value="null" disabled>-- Please select a Region --</b-form-select-option>
                    </template>
                 </b-form-select>
                 <b-form-input class="mt-3"
                    id="input-city"
                    v-model="userForm.city"
                    placeholder="Your city"
                 ></b-form-input>
               </b-form-group>
               Fill in fields below if you wish to change your password
                <b-form-group class="pt-2">
                  <b-form-input
                    id="input-password"
                    type="password"
                    v-model="userForm.password"
                    placeholder="Enter password"
                  ></b-form-input>
                </b-form-group>
                <b-form-group class="pb-2">
                  <b-form-input
                    id="input-passwordC"
                    type="password"
                    v-model="userForm.passwordC"
                    placeholder="Confirm password"
                  ></b-form-input>
                  <b-form-text id="password-help-block">
                    Your password must be 8-20 characters long and include at least one lowercase letter, one uppercase letter, and one number.
                  </b-form-text>
                  <b-form-text v-if="showUpdate()">
                    <b-button block variant="primary mt-4" :disabled=fieldsChanged()
                       @click="doUpdate">
                       Update
                    </b-button>
                  </b-form-text>
                  <b-form-text v-if="!showUpdate()">
                    <b-button block variant="warning mt-4">
                       ...Updating
                    </b-button>
                  </b-form-text>
                </b-form-group>
              </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
      </b-col>
   </b-row>
   
    <b-row align-h="center">
        <b-col md="10">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.dc-loc>
               Server Location
             </b-button>
           </b-card-header>
           <b-collapse id="dc-loc" accordion="my-accordion" role="tabpanel">
             <b-button-group class="float-right">
                <b-button variant="primary" size="sm"
                  @click="refresh_dc">
                  Refresh
                </b-button>
             </b-button-group>
                  <b-table
                    striped
                    show-empty
                    stacked="sm"
                    :fields="dcFields"
                    :items="dcs"
                    small
                  >
                  <template v-slot:cell(selected)="data">
                    <b-button v-if="data.item.selected && !data.item.user"
                      variant="success" size="sm" disabled
                      >
                      Auto Selected
                    </b-button>
                    <b-button v-if="data.item.selected && data.item.user"
                      variant="success" size="sm" disabled
                      >
                      User Selected
                    </b-button>
                    <b-button v-if="!data.item.selected"
                      variant="outline-primary" size="sm"
                      @click="change_dc(data.item)">
                      Select
                    </b-button>
                  </template>
                  </b-table>           
           </b-collapse>
         </b-card>
      </b-col>
    </b-row>


    <b-row align-h="center" v-if="plan.name">
        <b-col md="10">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.myplan>
               Manage Plan
             </b-button>
           </b-card-header>
           <b-collapse id="myplan" accordion="my-accordion" role="tabpanel">
             <b-row align-h="center" v-if="plan.name != 'cancel'">
               <b-col sm="2" style="margin-top:0.5rem;font-weight:600;">
                 {{ plan.dname }}
               </b-col>
               <b-col sm="3">
                <b-button variant="primary" size="sm"
                  @click="plan_upgrade">
                  Upgrade Plan
                </b-button>
               </b-col>
               <b-col>
                <b-button-group class="float-right">
                  <b-button variant="primary" size="sm"
                    @click="plan_cancel">
                    Cancel Plan
                  </b-button>
                </b-button-group>
               </b-col>
             </b-row>
             <b-row v-if="plan.name == 'cancel'">
               <b-col sm="9">
                  You have cancelled your subscription. Your plan will continue through the end of the current pay period.
               </b-col>
               <b-col sm="3">
                <b-button variant="primary" size="sm"
                  @click="plan_upgrade">
                   Reactivate your subscription
                </b-button>
               </b-col>
             </b-row>
             <b-row>
               <b-col style="font-size:0.7rem;color:red;">
                 {{ plan_error }}
               </b-col>
             </b-row>
           </b-collapse>
         </b-card>
      </b-col>
    </b-row>

    <b-row align-h="center" v-if="!isGuest">
      <b-col md="10">
         <b-card no-body class="mb-1">
           <b-card-header header-tag="header" class="p-1" role="tab">
             <b-button block href="#" class="m-0 p-1" v-b-toggle.acc-sessions>
               Manage Your Open Sessions ({{ sessions.length }})
             </b-button>
           </b-card-header>
           <b-collapse id="acc-sessions" accordion="my-accordion" role="tabpanel">
             <b-card-body>
              <b-card-text>
                <b-row>
                  <b-col md="5">
                    <b-button md="4" block @click="getSessions()" variant="primary">
                      Refresh Sessions
                    </b-button>
                  </b-col>
                </b-row>
                <div class="mb-3">
                  <b-table
                    striped
                    show-empty
                    stacked="md"
                    :fields="sessionFields"
                    :items="sessions"
                    small
                  >
                   <template v-slot:cell(self)="data">
                    <b-button v-if="data.item.self && data.item.sameproc" size="sm"
                      disabled variant="outline-danger">
                      You
                    </b-button>
                    <b-button v-if="!data.item.self && data.item.sameproc" size="sm"
                      disabled variant="outline-danger">
                      {{ "#" + data.item.win }}
                    </b-button>
                    <b-button v-if="!data.item.sameproc" size="sm"
                      @click="killSession(data.item.cid)"
                      variant="danger">
                      Kill
                    </b-button>
                   </template>
                   <template v-slot:cell(app)="data">
                    <b-button v-if="data.item.app && data.item.disabled" size="sm"
                      @click="disableSession(data.item.cid,false)"
                      variant="outline-primary">
                      Enable App Forwarding
                    </b-button>
                    <b-button v-if="data.item.app && !data.item.disabled" size="sm"
                      @click="disableSession(data.item.cid,true)"
                      variant="warning">
                      Stop Forwarding
                    </b-button>
                    <b-button v-if="!data.item.app" size="sm"
                      disabled>
                      Browser
                    </b-button>
                   </template>
                   <template v-slot:cell(device)="data">
                    {{ "#" + data.item.device }}
                   </template>
                   <template v-slot:cell(kind)="data">
                    {{ data.item.kind+" #"+data.item.proc+((data.item.win>1)?(" ("+data.item.win+")"):"") }}
                   </template>
                  <template v-slot:cell(room)="data">
                    {{ (data.item.room == "-") ? "No room visited" : data.item.room }}
                   </template>
                  </b-table>
                </div>
               </b-card-text>
             </b-card-body>
           </b-collapse>
         </b-card>
       </b-col>
   </b-row>
   
</div>
</template>

<script>
import Vue from "vue";
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import { format, getUnixTime } from 'date-fns';
import crinfo from '@/cr.js'

export default {
  name: "account",
  data() {
    return {
      dcs: [],
      dcFields: [
          { key: "name", label: "Name"},
          { key: "lat", label: ""},
          { key: "selected", label: "Selected"},
      ],
      sessions: [],
      sessionFields: [
          { key: "self", label: ""},
          { key: "app", label: ""},
          { key: "device", label: "Device"},
          { key: "kind", label: "App"},
          //{ key: "room", label: ""},
      ],
      loc_cts:[],
      userForm: {
        email: "",
        nick: "",
        password: "",
        first_name: "",
        last_name: "",
        country: null,
        region: null,
        city: null,
      },
      plan: {name:"",
             },
      plan_error: "",
      isGuest: false,
    };
  },
  components: {
  },
  created() {
     let vue = this;
     vue.userForm.email = this.$parent.currentUser.email;
     vue.userForm.nick = this.$parent.currentUser.nick;
     vue.userForm.first_name = this.$parent.currentUser.first_name;
     vue.userForm.last_name = this.$parent.currentUser.last_name;
     vue.userForm.country = this.$parent.currentUser.loc.ct || null;
     vue.userForm.region = this.$parent.currentUser.loc.rg || null;
     vue.userForm.city = this.$parent.currentUser.loc.cy || null;
  },
  mounted() {
     let vue = this;
     vue.getSessions();
     vue.loc_cts = window.vx_populate_cts(crinfo);
     vue.update_dc();
     vue.isGuest = vx_is_guest(window.vx);
  },
  watch: {
  },
  beforeDestroy() {
     window.wss_clr_routes(window.vx,"account");
  },
  methods: {
    update_dc: function() {
      let vue = this;
      let selected = getLocal("vx_dc",true);
      let found = false;
      vue.dcs = [];
      vx.dc_list.forEach(function(dc) {
        let d = {};
        let info = vue.$parent.dc2name(dc);
        d.dc = dc;
        d.name = info.r + " ("+info.n+")";
        d.selected = false;
        d.user = false;
        //console.log("selected",selected,dc);
        if (selected && (selected.dc == dc || selected.user_dc == dc)) {
          d.selected = true;
          d.user = !!selected.user_dc;
          found = true;
        }
        vue.dcs.push(d);
      });
      if (selected && !found) {
         /* If no exact match found, allow a partial match.
          *  e.g. sjc1 matches sjc
          * selected.dc is the actual DC name. This should
          * be >= (same or more specific) than the DCs in
          * dc_list. */
         vue.dcs.forEach(function(d) {
            //console.log("selected Partial",selected,d.dc);
            if (!found && selected.dc.indexOf(d.dc) >= 0) {
              d.selected = true;
              d.user = !!selected.user_dc;
              found = true;
            }
         });
      }
    },
    change_dc: function(manual) {
      let vue = this;
      let info = {};
      info.user_dc = manual.dc;
      setLocal("vx_dc",JSON.stringify(info));

      /* Updates domains and calls vuemixly_set_vs_template using
       *   manually set info above */
      window.vx_select_dc();
      vue.update_dc();
    },
    refresh_dc: function(dc) {
      let vue = this;
      window.vx_clear_dc();

      /* Callback issued once select_dc finishes */
      window.vuemix_vs_selected(function() {
        console.log("dc selected");
        vue.update_dc();
      });

      /* Updates domains and calls vuemixly_set_vs_template using
       *   manually set info above and triggers callback above */
      window.vx_select_dc();
    },
    showUpdate: function() {
      let vue = this;
      if (vue.update_submitted) { return false; }
      return true;
    },
    fieldsChanged: function() {
      let vue = this;
      if (vue.$parent.currentUser.first_name == vue.userForm.first_name &&
          vue.$parent.currentUser.last_name == vue.userForm.last_name &&
          vue.$parent.currentUser.country == vue.userForm.country &&
          vue.$parent.currentUser.region == vue.userForm.region &&
          vue.$parent.currentUser.city == vue.userForm.city &&
          !vue.userForm.password) {
          return true;
      }
      return false;
    },
    goHome: function() {
      this.$router.push({ name: 'home' });
    },
    validateEmail: function(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    doUpdate: function() {
      let vue = this;
      let data = {};

      if (vue.userForm.password) {
        if (vue.userForm.password.length <= 7) {
          vue.$parent.notification = { alertCountDown: 4,
              alertVariant: "danger",
              alertMessage: "Password is too short" };
          return;         
        }
        if (vue.userForm.password.length > 20) {
          vue.$parent.notification = { alertCountDown: 4,
              alertVariant: "danger",
              alertMessage: "Password is too long" };
          return;         
        }
        if (!vue.userForm.password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/)) {
          vue.$parent.notification = { alertCountDown: 4,
              alertVariant: "danger",
              alertMessage: "Password must include at least one lowercase letter, one uppercase letter, and one number." };
          return;
        }
        if (vue.userForm.password != vue.userForm.passwordC) {
          vue.$parent.notification = { alertCountDown: 4,
              alertVariant: "danger",
              alertMessage: "Passwords do not match" };
          return;
        }
        data.password= vue.userForm.password;
      }
      if (vue.userForm.first_name) {
        data.first_name = vue.userForm.first_name;
      }
      if (vue.userForm.last_name) {
        data.last_name = vue.userForm.last_name;
      }
      if (vue.userForm.country) {
        data.loc = data.loc || {};
        data.loc.ct = vue.userForm.country;
      }
      if (vue.userForm.region) {
        data.loc = data.loc || {};
        data.loc.rg = vue.userForm.region;
      }
      if (vue.userForm.city) {
        data.loc = data.loc || {};
        data.loc.cy = vue.userForm.city;
      }
      
      vue.update_submitted = true;
      window.api_user_update(window.vx, data, function(err,data) {
         vue.update_submitted = false;
         if (err) {
            vue.$parent.notification = { alertCountDown: 4,
               alertVariant: "danger",
               alertMessage: err.msg };
         } else {
            vue.$parent.notification = { alertCountDown: 4,
               alertVariant: "success",
               alertMessage: "Updated" };
            vx_api.getSelf(window.vx).then(self_res => {
               vue.$parent.currentUser.first_name = self_res.first_name;
               vue.$parent.currentUser.last_name = self_res.last_name;
               vue.$parent.currentUser.short_name = self_res.short_name;
               vue.$parent.currentUser.loc = self_res.loc;
           });
         }
      });
    },
    wss_get_remotes: function(msg) {    
      let vue=this;
      let devh = {};
      let device = 1;
      if (wss_ishash(msg)) {
        msg.data.forEach(function(s) {
          let rec = {};          
          rec.disabled = s.disabled;
          rec.self = s.self;
          rec.cid = s.cid;
          rec.uid = s.uid;
          rec.room = s.room;
          if (!s.app) {
            rec.app = false;
            rec.kind = "Browser";
            rec.uuid = "zbrowser";
            rec.uwid = s.app.uwid || "y";
            rec.disabled = true;
          } else {
            rec.app = true;
            if (s.app.kind == "chrome") {
              rec.kind = "Desktop";
            } else {
              rec.kind = s.app.kind;
            }
            rec.uuid = s.app.uuid || "x";
            rec.uwid = s.app.uwid || "y";
          }
          if (!devh[rec.uuid]) {
            devh[rec.uuid] = {d: device++, p:0, proch:{}};
          }
          let dev = devh[rec.uuid];
          if (!dev.proch[rec.uwid]) {
            dev.p++;
            dev.proch[rec.uwid] = {p:dev.p, w:0, recs:[]};            
          }
          let proc = dev.proch[rec.uwid];
          proc.w++;

          rec.device = dev.d;
          rec.proc = proc.p;
          rec.win = proc.w;
          if (rec.self) { proc.self = true; }
          proc.recs.push(rec);
        });
      }

      /* This results in grouping by device/proc/window */
      let ss=[];
      Object.keys(devh).forEach(function(dev) {
        Object.keys(devh[dev].proch).forEach(function(proc) {
          devh[dev].proch[proc].recs.forEach(function(s) {
            if (devh[dev].proch[proc].self) {
              s.sameproc = true;
            }
            ss.push(s);
          });
        });
      });
      vue.sessions = ss;
    },
    getSessions: function() {
       let vue=this;
       if (!vue.$router.currentRoute.params || !vue.$router.currentRoute.params.uid) { return; }
       window.vx_set_room(vx, vue.$router.currentRoute.params.acc, vue.$router.currentRoute.params.uid);
       window.wss_open(vx, {
         acc: vx.room.acc,
         room: vx.room.name,
         uid: vx.user.id,
         routes_id: "account",
         routes: {         
           auth_me: function(){
             window.wss_send(vx, "get_remotes", {});
             window.wss_send(vx, "auth_room", {
               cred: vx.user.creds["myroom"]
             });
           },
           auth_room: function(msg) {
             window.wss_send(vx, "get_room_ctrl", {});
           },
           room_ctrl: function(msg) {
             if (msg.data.plan) {
               vue.plan.name = msg.data.plan.name;
               if (vue.plan.name == "trial") {
                 vue.plan.dname = "Free Trial";
               } else if (vue.plan.name == "basic") {
                 vue.plan.dname = "Basic";
               } else if (vue.plan.name == "premium") {
                 vue.plan.dname = "Premium";
               }
             }
           },
           set_room_plan: function(msg) {
             if (msg.data.error) {
               vue.plan_error = msg.data.error;
             } else {
               setTimeout(vue.getSessions, 1000);
             }
           },
           get_remotes: vue.wss_get_remotes,
           cfg_remote: function() {
             window.wss_send(vx, "get_remotes", {});
           },
           send_remote: function() {
             window.wss_send(vx, "get_remotes", {});
           },
         }
       });
    },
    disableSession: function (cid, disable) {
      window.wss_send(window.vx, "cfg_remote",
                      {to_cid:cid, set_conn:{disabled: disable}});
    },
    killSession: function (cid) {
      window.wss_send(window.vx, "send_remote",
                      {to_cid:cid, msg:{kill:true}});
    },
    plan_upgrade: function() {
      this.$router.push({name: 'hosting'});
    },
    plan_cancel: function() {
      window.wss_send(window.vx, "set_room_plan",
                     { subd: vx.subd,
                       plan:{
                         name: "cancel"
                       },
                       trans:{
                         id: "cancel",
                       },
                      });
    },
  },
  computed: {
    loc_rgs : function() {
      return window.vx_populate_rgs(crinfo, this.userForm.country);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}
</style>
